import { Breakpoints } from '@careerhub/common';
import { makeStyles } from '@fluentui/react-components';

export const useCardsCarouselStyles = makeStyles({
  stack: {
    display: 'flex',
    flexWrap: 'wrap',
    height: 'fit-content',
    boxSizing: 'border-box',
    '> *': {
      textOverflow: 'ellipsis',
    },
    marginTop: '16px',
    marginBottom: 0,
    paddingLeft: 0,
    listStyleType: 'none',
    columnGap: '12px',
  },
  stackitem: {
    display: 'flex',
    width: 'fit-content',
    minWidth: 0,
    maxWidth: '100%',
    alignSelf: 'stretch',
    flexShrink: 1,
    marginBottom: '12px',
    '@media (max-width: 360px)': {
      width: '100%',
    },
  },
  homepageStack: {
    display: 'flex',
    height: 'fit-content',
    boxSizing: 'border-box',
    [Breakpoints.xl]: {
      flexWrap: 'wrap',
    },
    '> *': {
      textOverflow: 'ellipsis',
    },
    marginTop: '16px',
    marginBottom: 0,
    paddingLeft: 0,
    listStyleType: 'none',
    columnGap: '12px',
  },
  homepageStackitem: {
    display: 'flex',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    [Breakpoints.xl]: {
      width: 'fit-content',
    },
    alignSelf: 'stretch',
    flexShrink: 1,
    marginBottom: '12px',
  },
});
